export const MATCH_PATTERN = /^[0-9]{5}$/;
